import * as TYPES from '../types';

export const addProjectAction = (payload) => {
    return {
        type: TYPES.ADD_PROJECT,
        payload: payload
    };
};

export const getAllProjectAction = () => {
    return {
        type: TYPES.GET_ALL_PROJECT,
    };
};

export const getAllProjectSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_PROJECT_SUCCESS,
        payload: payload
    };
};

export const deleteProjectAction = (payload) => {
    return {
        type: TYPES.DELETE_PROJECT,
        payload: payload
    };
};

export const editProjectAction = (payload) => {
    return {
        type: TYPES.EDIT_PROJECT,
        payload: payload
    };
};

export const addUpcommingProjectAction = (payload) => {
    return {
        type: TYPES.ADD_UPCOMMING_PROJECT,
        payload: payload
    };
};
